import { Link } from 'react-router-dom';
import { LegalChrome } from './LegalChrome';
import { MAILING_ADDRESS, SUPPORT_EMAIL } from './constants';

const LAST_UPDATED = 'April 17, 2026';

export function HelpCenterPage() {
  return (
    <LegalChrome>
      <h1 className="legal-h1">Help center — Child safety & reporting</h1>
      <p className="legal-muted">Last updated: {LAST_UPDATED}</p>

      <p className="legal-p">
        This article supplements <strong>Child Safety Standards for Kynward</strong> — the canonical
        public page for CSAE rules, reporting in-app, enforcement, and designated child-safety
        contact.{' '}
        <Link className="legal-a" to="/child-safety">
          Open Child Safety Standards
        </Link>
        , or use the URL from your app store listing.
      </p>
      <p className="legal-p">
        Below we summarize how Kynward approaches compliance with applicable child safety laws and
        how we report to regional, national, and other competent authorities when required.
      </p>

      <h2 className="legal-h2">Compliance</h2>
      <p className="legal-p">
        We maintain practices designed to comply with relevant child safety and online safety
        obligations in the jurisdictions where we operate, including requirements related to CSAE
        and CSAM, reporting, and cooperation with regulators and law enforcement.
      </p>

      <h2 className="legal-h2">Reporting to authorities</h2>
      <p className="legal-p">
        When we become aware of apparent child sexual abuse material (CSAM), grooming, or other
        conduct that raises serious child safety concerns, we may take action including content
        removal, account termination, and preservation of records in line with legal process.
      </p>
      <p className="legal-p">
        Where applicable law requires, we report to national or regional bodies — for example, in
        the United States, reports may be submitted to the National Center for Missing & Exploited
        Children (NCMEC), including via the CyberTipline, as appropriate. In other regions, we
        cooperate with competent local authorities and hotlines as required by applicable law.
      </p>
      <p className="legal-p">
        Specific reporting paths depend on jurisdiction, the nature of the content, and legal
        requirements; we do not publicly document every internal escalation or law-enforcement
        interaction.
      </p>

      <h2 className="legal-h2">What you can do</h2>
      <p className="legal-p">
        Use in-app reporting and blocking for policy violations. For urgent matters involving
        imminent danger, contact local emergency services. For questions about this process, email
        us — we cannot provide legal advice.
      </p>

      <h2 className="legal-h2">Contact</h2>
      <p className="legal-p" style={{ fontWeight: 600 }}>
        Elyxora Works, LLC
      </p>
      <div className="legal-contact-line">
        <span>Email: </span>
        <a className="legal-a" href={`mailto:${SUPPORT_EMAIL}`}>
          {SUPPORT_EMAIL}
        </a>
      </div>
      <p className="legal-p">Address: {MAILING_ADDRESS}</p>
    </LegalChrome>
  );
}
